import React, { useState } from 'react';
import { useFetch } from '../../hooks/useFetch';
import { useToast, Spinner, ErrorBanner, Badge, EmptyState } from '../../components/ui';
import AddRMAModal from './AddRMA';
import { fmt, errMsg } from '../../utils/format';
import api from '../../utils/api';

export default function RMA() {
  const [status, setStatus] = useState('pending');
  const [addModal, setAddModal] = useState(false);
  const { data, loading, error, refetch } = useFetch(`/api/rma?status=${status}`, [status]);
  const { showToast, Toast } = useToast();

  const process = async (id) => {
    if (!window.confirm('Process this RMA? If restock is enabled, inventory will be updated.')) return;
    try { await api.post(`/api/rma/${id}/process`); refetch(); showToast('RMA processed successfully'); } catch (err) { alert(errMsg(err)); }
  };

  if (loading) return <Spinner />;
  if (error) return <ErrorBanner message={error} onRetry={refetch} />;
  return (
    <div>

      <div className="page-header">
        <h1>Returns / RMA</h1>
        <div className="page-actions">
          <select value={status} onChange={e => setStatus(e.target.value)}>
            <option value="pending">Pending</option><option value="processed">Processed</option><option value="rejected">Rejected</option>
          </select>
          <button className="btn btn-primary btn-sm" onClick={() => setAddModal(true)}><i className="ti ti-plus" /> New RMA</button>
        </div>
      </div>
      {addModal && <AddRMAModal onClose={() => setAddModal(false)} onSaved={(msg) => { refetch(); showToast(msg || 'Saved'); }} />}
      <div className="card">
        <div className="table-wrap">
          <table>
            <thead><tr><th>Product</th><th>SKU</th><th>Qty</th><th>Reason</th><th>Restock</th><th>Order</th><th>Status</th><th>Actions</th></tr></thead>
            <tbody>
              {(data || []).map(r => (
                <tr key={r.id}>
                  <td>{r.product_name || r.sku}</td>
                  <td style={{ fontFamily:'monospace', fontSize:12 }}>{r.sku}</td>
                  <td>{r.quantity}</td>
                  <td style={{ fontSize:12, color:'var(--text-secondary)' }}>{r.reason || '—'}</td>
                  <td>{r.restock ? <span className="badge badge-ok">Yes</span> : <span className="badge badge-gray">No</span>}</td>
                  <td style={{ fontSize:12 }}>{r.order_ref || '—'}</td>
                  <td><Badge status={r.status} /></td>
                  <td>{r.status === 'pending' && <button className="btn btn-sm btn-primary" onClick={() => process(r.id)}>Process</button>}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {!(data||[]).length && <EmptyState icon="ti-arrow-back-up" message="No RMAs found" />}
        </div>
      </div>
    </div>
  );
}
